export const cWaterDropIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" viewBox="0 0 24 24"><rect fill="none" height="24" width="24"/><path d="M12,2c-5.33,4.55-8,8.48-8,11.8c0,4.98,3.8,8.2,8,8.2s8-3.22,8-8.2C20,10.48,17.33,6.55,12,2z M13,18.91 C12.68,18.97,12.35,19,12,19c-2.69,0-4.88-1.94-5-5h1.5c0.08,2.07,1.5,3.5,3.5,3.5c0.35,0,0.69-0.04,1-0.13V18.91z"/></svg>`,
  name: 'c-water-drop',
};
